export default "__VITE_ASSET__DC7JxO8z__"